/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SelectProductRouteImport } from './routes/select-product'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as MagicLinkRouteImport } from './routes/magic-link'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password.index'
import { Route as MagicLinkIndexRouteImport } from './routes/magic-link.index'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as VerifyEmailTokenRouteImport } from './routes/verify-email.$token'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as MfaVerifyRouteImport } from './routes/mfa.verify'
import { Route as MfaSetupRouteImport } from './routes/mfa.setup'
import { Route as MfaRecoveryRouteImport } from './routes/mfa.recovery'
import { Route as MagicLinkTokenRouteImport } from './routes/magic-link.$token'
import { Route as LoginPasskeyRouteImport } from './routes/login.passkey'
import { Route as InvitationTokenRouteImport } from './routes/invitation.$token'
import { Route as AccountSessionsRouteImport } from './routes/account.sessions'
import { Route as AccountSecurityRouteImport } from './routes/account.security'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountDataRouteImport } from './routes/account.data'
import { Route as AccountCredentialsRouteImport } from './routes/account.credentials'
import { Route as AccountConnectedAppsRouteImport } from './routes/account.connected-apps'
import { Route as AccountAuditLogRouteImport } from './routes/account.audit-log'
import { Route as AccountMcpIndexRouteImport } from './routes/account.mcp.index'
import { Route as AccountMcpStepUpRouteImport } from './routes/account.mcp.step-up'
import { Route as AccountMcpRevealIdRouteImport } from './routes/account.mcp.reveal.$id'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const SelectProductRoute = SelectProductRouteImport.update({
  id: '/select-product',
  path: '/select-product',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLinkRoute = MagicLinkRouteImport.update({
  id: '/magic-link',
  path: '/magic-link',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LaunchRoute = LaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResetPasswordRoute,
} as any)
const MagicLinkIndexRoute = MagicLinkIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MagicLinkRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const VerifyEmailTokenRoute = VerifyEmailTokenRouteImport.update({
  id: '/verify-email/$token',
  path: '/verify-email/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => ResetPasswordRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaVerifyRoute = MfaVerifyRouteImport.update({
  id: '/mfa/verify',
  path: '/mfa/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaSetupRoute = MfaSetupRouteImport.update({
  id: '/mfa/setup',
  path: '/mfa/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaRecoveryRoute = MfaRecoveryRouteImport.update({
  id: '/mfa/recovery',
  path: '/mfa/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const MagicLinkTokenRoute = MagicLinkTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => MagicLinkRoute,
} as any)
const LoginPasskeyRoute = LoginPasskeyRouteImport.update({
  id: '/passkey',
  path: '/passkey',
  getParentRoute: () => LoginRoute,
} as any)
const InvitationTokenRoute = InvitationTokenRouteImport.update({
  id: '/invitation/$token',
  path: '/invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSessionsRoute = AccountSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AccountRoute,
} as any)
const AccountSecurityRoute = AccountSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AccountRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRoute,
} as any)
const AccountDataRoute = AccountDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AccountRoute,
} as any)
const AccountCredentialsRoute = AccountCredentialsRouteImport.update({
  id: '/credentials',
  path: '/credentials',
  getParentRoute: () => AccountRoute,
} as any)
const AccountConnectedAppsRoute = AccountConnectedAppsRouteImport.update({
  id: '/connected-apps',
  path: '/connected-apps',
  getParentRoute: () => AccountRoute,
} as any)
const AccountAuditLogRoute = AccountAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AccountRoute,
} as any)
const AccountMcpIndexRoute = AccountMcpIndexRouteImport.update({
  id: '/mcp/',
  path: '/mcp/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountMcpStepUpRoute = AccountMcpStepUpRouteImport.update({
  id: '/mcp/step-up',
  path: '/mcp/step-up',
  getParentRoute: () => AccountRoute,
} as any)
const AccountMcpRevealIdRoute = AccountMcpRevealIdRouteImport.update({
  id: '/mcp/reveal/$id',
  path: '/mcp/reveal/$id',
  getParentRoute: () => AccountRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/device': typeof DeviceRoute
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/magic-link': typeof MagicLinkRouteWithChildren
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/select-product': typeof SelectProductRoute
  '/welcome': typeof WelcomeRoute
  '/account/audit-log': typeof AccountAuditLogRoute
  '/account/connected-apps': typeof AccountConnectedAppsRoute
  '/account/credentials': typeof AccountCredentialsRoute
  '/account/data': typeof AccountDataRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/security': typeof AccountSecurityRoute
  '/account/sessions': typeof AccountSessionsRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/login/passkey': typeof LoginPasskeyRoute
  '/magic-link/$token': typeof MagicLinkTokenRoute
  '/mfa/recovery': typeof MfaRecoveryRoute
  '/mfa/setup': typeof MfaSetupRoute
  '/mfa/verify': typeof MfaVerifyRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/verify-email/$token': typeof VerifyEmailTokenRoute
  '/account/': typeof AccountIndexRoute
  '/login/': typeof LoginIndexRoute
  '/magic-link/': typeof MagicLinkIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/account/mcp/step-up': typeof AccountMcpStepUpRoute
  '/account/mcp/': typeof AccountMcpIndexRoute
  '/account/mcp/reveal/$id': typeof AccountMcpRevealIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/device': typeof DeviceRoute
  '/launch': typeof LaunchRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/select-product': typeof SelectProductRoute
  '/welcome': typeof WelcomeRoute
  '/account/audit-log': typeof AccountAuditLogRoute
  '/account/connected-apps': typeof AccountConnectedAppsRoute
  '/account/credentials': typeof AccountCredentialsRoute
  '/account/data': typeof AccountDataRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/security': typeof AccountSecurityRoute
  '/account/sessions': typeof AccountSessionsRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/login/passkey': typeof LoginPasskeyRoute
  '/magic-link/$token': typeof MagicLinkTokenRoute
  '/mfa/recovery': typeof MfaRecoveryRoute
  '/mfa/setup': typeof MfaSetupRoute
  '/mfa/verify': typeof MfaVerifyRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/verify-email/$token': typeof VerifyEmailTokenRoute
  '/account': typeof AccountIndexRoute
  '/login': typeof LoginIndexRoute
  '/magic-link': typeof MagicLinkIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/account/mcp/step-up': typeof AccountMcpStepUpRoute
  '/account/mcp': typeof AccountMcpIndexRoute
  '/account/mcp/reveal/$id': typeof AccountMcpRevealIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/device': typeof DeviceRoute
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRouteWithChildren
  '/logout': typeof LogoutRoute
  '/magic-link': typeof MagicLinkRouteWithChildren
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRouteWithChildren
  '/select-product': typeof SelectProductRoute
  '/welcome': typeof WelcomeRoute
  '/account/audit-log': typeof AccountAuditLogRoute
  '/account/connected-apps': typeof AccountConnectedAppsRoute
  '/account/credentials': typeof AccountCredentialsRoute
  '/account/data': typeof AccountDataRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/security': typeof AccountSecurityRoute
  '/account/sessions': typeof AccountSessionsRoute
  '/invitation/$token': typeof InvitationTokenRoute
  '/login/passkey': typeof LoginPasskeyRoute
  '/magic-link/$token': typeof MagicLinkTokenRoute
  '/mfa/recovery': typeof MfaRecoveryRoute
  '/mfa/setup': typeof MfaSetupRoute
  '/mfa/verify': typeof MfaVerifyRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/verify-email/$token': typeof VerifyEmailTokenRoute
  '/account/': typeof AccountIndexRoute
  '/login/': typeof LoginIndexRoute
  '/magic-link/': typeof MagicLinkIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/account/mcp/step-up': typeof AccountMcpStepUpRoute
  '/account/mcp/': typeof AccountMcpIndexRoute
  '/account/mcp/reveal/$id': typeof AccountMcpRevealIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/device'
    | '/launch'
    | '/login'
    | '/logout'
    | '/magic-link'
    | '/register'
    | '/reset-password'
    | '/select-product'
    | '/welcome'
    | '/account/audit-log'
    | '/account/connected-apps'
    | '/account/credentials'
    | '/account/data'
    | '/account/profile'
    | '/account/security'
    | '/account/sessions'
    | '/invitation/$token'
    | '/login/passkey'
    | '/magic-link/$token'
    | '/mfa/recovery'
    | '/mfa/setup'
    | '/mfa/verify'
    | '/oauth/consent'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/account/'
    | '/login/'
    | '/magic-link/'
    | '/reset-password/'
    | '/account/mcp/step-up'
    | '/account/mcp/'
    | '/account/mcp/reveal/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/device'
    | '/launch'
    | '/logout'
    | '/register'
    | '/select-product'
    | '/welcome'
    | '/account/audit-log'
    | '/account/connected-apps'
    | '/account/credentials'
    | '/account/data'
    | '/account/profile'
    | '/account/security'
    | '/account/sessions'
    | '/invitation/$token'
    | '/login/passkey'
    | '/magic-link/$token'
    | '/mfa/recovery'
    | '/mfa/setup'
    | '/mfa/verify'
    | '/oauth/consent'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/account'
    | '/login'
    | '/magic-link'
    | '/reset-password'
    | '/account/mcp/step-up'
    | '/account/mcp'
    | '/account/mcp/reveal/$id'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/device'
    | '/launch'
    | '/login'
    | '/logout'
    | '/magic-link'
    | '/register'
    | '/reset-password'
    | '/select-product'
    | '/welcome'
    | '/account/audit-log'
    | '/account/connected-apps'
    | '/account/credentials'
    | '/account/data'
    | '/account/profile'
    | '/account/security'
    | '/account/sessions'
    | '/invitation/$token'
    | '/login/passkey'
    | '/magic-link/$token'
    | '/mfa/recovery'
    | '/mfa/setup'
    | '/mfa/verify'
    | '/oauth/consent'
    | '/reset-password/$token'
    | '/verify-email/$token'
    | '/account/'
    | '/login/'
    | '/magic-link/'
    | '/reset-password/'
    | '/account/mcp/step-up'
    | '/account/mcp/'
    | '/account/mcp/reveal/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  LaunchRoute: typeof LaunchRoute
  LoginRoute: typeof LoginRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  MagicLinkRoute: typeof MagicLinkRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRouteWithChildren
  SelectProductRoute: typeof SelectProductRoute
  WelcomeRoute: typeof WelcomeRoute
  InvitationTokenRoute: typeof InvitationTokenRoute
  MfaRecoveryRoute: typeof MfaRecoveryRoute
  MfaSetupRoute: typeof MfaSetupRoute
  MfaVerifyRoute: typeof MfaVerifyRoute
  OauthConsentRoute: typeof OauthConsentRoute
  VerifyEmailTokenRoute: typeof VerifyEmailTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/select-product': {
      id: '/select-product'
      path: '/select-product'
      fullPath: '/select-product'
      preLoaderRoute: typeof SelectProductRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-link': {
      id: '/magic-link'
      path: '/magic-link'
      fullPath: '/magic-link'
      preLoaderRoute: typeof MagicLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/launch': {
      id: '/launch'
      path: '/launch'
      fullPath: '/launch'
      preLoaderRoute: typeof LaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof ResetPasswordRoute
    }
    '/magic-link/': {
      id: '/magic-link/'
      path: '/'
      fullPath: '/magic-link/'
      preLoaderRoute: typeof MagicLinkIndexRouteImport
      parentRoute: typeof MagicLinkRoute
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/verify-email/$token': {
      id: '/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/verify-email/$token'
      preLoaderRoute: typeof VerifyEmailTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof ResetPasswordRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa/verify': {
      id: '/mfa/verify'
      path: '/mfa/verify'
      fullPath: '/mfa/verify'
      preLoaderRoute: typeof MfaVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa/setup': {
      id: '/mfa/setup'
      path: '/mfa/setup'
      fullPath: '/mfa/setup'
      preLoaderRoute: typeof MfaSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa/recovery': {
      id: '/mfa/recovery'
      path: '/mfa/recovery'
      fullPath: '/mfa/recovery'
      preLoaderRoute: typeof MfaRecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magic-link/$token': {
      id: '/magic-link/$token'
      path: '/$token'
      fullPath: '/magic-link/$token'
      preLoaderRoute: typeof MagicLinkTokenRouteImport
      parentRoute: typeof MagicLinkRoute
    }
    '/login/passkey': {
      id: '/login/passkey'
      path: '/passkey'
      fullPath: '/login/passkey'
      preLoaderRoute: typeof LoginPasskeyRouteImport
      parentRoute: typeof LoginRoute
    }
    '/invitation/$token': {
      id: '/invitation/$token'
      path: '/invitation/$token'
      fullPath: '/invitation/$token'
      preLoaderRoute: typeof InvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/sessions': {
      id: '/account/sessions'
      path: '/sessions'
      fullPath: '/account/sessions'
      preLoaderRoute: typeof AccountSessionsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/security': {
      id: '/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AccountSecurityRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/data': {
      id: '/account/data'
      path: '/data'
      fullPath: '/account/data'
      preLoaderRoute: typeof AccountDataRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/credentials': {
      id: '/account/credentials'
      path: '/credentials'
      fullPath: '/account/credentials'
      preLoaderRoute: typeof AccountCredentialsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/connected-apps': {
      id: '/account/connected-apps'
      path: '/connected-apps'
      fullPath: '/account/connected-apps'
      preLoaderRoute: typeof AccountConnectedAppsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/audit-log': {
      id: '/account/audit-log'
      path: '/audit-log'
      fullPath: '/account/audit-log'
      preLoaderRoute: typeof AccountAuditLogRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/mcp/': {
      id: '/account/mcp/'
      path: '/mcp'
      fullPath: '/account/mcp/'
      preLoaderRoute: typeof AccountMcpIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/mcp/step-up': {
      id: '/account/mcp/step-up'
      path: '/mcp/step-up'
      fullPath: '/account/mcp/step-up'
      preLoaderRoute: typeof AccountMcpStepUpRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/mcp/reveal/$id': {
      id: '/account/mcp/reveal/$id'
      path: '/mcp/reveal/$id'
      fullPath: '/account/mcp/reveal/$id'
      preLoaderRoute: typeof AccountMcpRevealIdRouteImport
      parentRoute: typeof AccountRoute
    }
  }
}

interface AccountRouteChildren {
  AccountAuditLogRoute: typeof AccountAuditLogRoute
  AccountConnectedAppsRoute: typeof AccountConnectedAppsRoute
  AccountCredentialsRoute: typeof AccountCredentialsRoute
  AccountDataRoute: typeof AccountDataRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountSecurityRoute: typeof AccountSecurityRoute
  AccountSessionsRoute: typeof AccountSessionsRoute
  AccountIndexRoute: typeof AccountIndexRoute
  AccountMcpStepUpRoute: typeof AccountMcpStepUpRoute
  AccountMcpIndexRoute: typeof AccountMcpIndexRoute
  AccountMcpRevealIdRoute: typeof AccountMcpRevealIdRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountAuditLogRoute: AccountAuditLogRoute,
  AccountConnectedAppsRoute: AccountConnectedAppsRoute,
  AccountCredentialsRoute: AccountCredentialsRoute,
  AccountDataRoute: AccountDataRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountSecurityRoute: AccountSecurityRoute,
  AccountSessionsRoute: AccountSessionsRoute,
  AccountIndexRoute: AccountIndexRoute,
  AccountMcpStepUpRoute: AccountMcpStepUpRoute,
  AccountMcpIndexRoute: AccountMcpIndexRoute,
  AccountMcpRevealIdRoute: AccountMcpRevealIdRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface LoginRouteChildren {
  LoginPasskeyRoute: typeof LoginPasskeyRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginPasskeyRoute: LoginPasskeyRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

interface MagicLinkRouteChildren {
  MagicLinkTokenRoute: typeof MagicLinkTokenRoute
  MagicLinkIndexRoute: typeof MagicLinkIndexRoute
}

const MagicLinkRouteChildren: MagicLinkRouteChildren = {
  MagicLinkTokenRoute: MagicLinkTokenRoute,
  MagicLinkIndexRoute: MagicLinkIndexRoute,
}

const MagicLinkRouteWithChildren = MagicLinkRoute._addFileChildren(
  MagicLinkRouteChildren,
)

interface ResetPasswordRouteChildren {
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
}

const ResetPasswordRouteChildren: ResetPasswordRouteChildren = {
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
}

const ResetPasswordRouteWithChildren = ResetPasswordRoute._addFileChildren(
  ResetPasswordRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  DeviceRoute: DeviceRoute,
  LaunchRoute: LaunchRoute,
  LoginRoute: LoginRouteWithChildren,
  LogoutRoute: LogoutRoute,
  MagicLinkRoute: MagicLinkRouteWithChildren,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRouteWithChildren,
  SelectProductRoute: SelectProductRoute,
  WelcomeRoute: WelcomeRoute,
  InvitationTokenRoute: InvitationTokenRoute,
  MfaRecoveryRoute: MfaRecoveryRoute,
  MfaSetupRoute: MfaSetupRoute,
  MfaVerifyRoute: MfaVerifyRoute,
  OauthConsentRoute: OauthConsentRoute,
  VerifyEmailTokenRoute: VerifyEmailTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
